import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Divider,
  Typography,
  Checkbox,
  Row,
  Col,
  Radio,
  Select,
} from "antd";
import { initUser,initSchool, School,Hospital, initHospital } from "../../models";
import { getTable, getTableAll } from "../../api/Api";
import { loginInfo } from "../../config";
import { useHistory } from "react-router-dom";

interface PropsType {
  visible: boolean;
  add: Function;
  setInvisible: Function;
}
export const AddForm: React.FC<PropsType> = ({
  visible,
  add,
  setInvisible,
}) => {
  const [userType, setUserType] = useState(0);
  const [school, setSchool] = useState(initSchool);
  const [hospital, setHospital] = useState(initHospital);
  const [schoolOptions,setSchoolOptions] = useState<any[]>([]);
  const [hospitalOptions,setHospitalOptions] = useState<any[]>([]);
  const [form] = Form.useForm();
  const history = useHistory();
  useEffect(() => {
    form.setFieldsValue({ ...initUser,hospital:undefined,school:undefined });
    _getHospitals();
  }, [visible, form]);

  const _getHospitals = async() =>{
    let data = await getTableAll("hospital");
    if(typeof data === "undefined"){
      history.push("/");      
    }
    let items: any[] = [];
    data.forEach((s) => {
      items.push(
        <Select.Option key={s.id} value={s.id}>
          {s.hospitalName}
        </Select.Option>
      );
    });
    setHospitalOptions(items);
  }
  const _getSchools = async(hospitalId:number) =>{
    let data = await getTableAll("school");
    if(typeof data === "undefined"){
      history.push("/");      
    }
    let items: any[] = [];
    data.forEach((s) => {
      if(s.hospitalId === hospitalId){
      items.push(        
        <Select.Option key={s.id} value={s.id}>
          {s.schoolName}
        </Select.Option>
      );
      }
    });
    setSchoolOptions(items);
  }
  const handlerOk = () => {
    add({
      ...loginInfo.user,
      id: -1,
      key: -1,
      type: userType,
      schoolId: school.id,
      schoolName: school.schoolName,
      hospitalId: hospital.id,
      hospitalName: hospital.hospitalName,
      userCode: form.getFieldValue("userCode"),
      userPwd: "abc123",
      userName: form.getFieldValue("userName"),
      add: form.getFieldValue("add"),
      update: form.getFieldValue("update"),
      delete: form.getFieldValue("delete"),
      check: form.getFieldValue("check"),
      report: form.getFieldValue("report"),
      user: form.getFieldValue("user"),
      data: form.getFieldValue("data"),
      count: form.getFieldValue("count"),
    });
    setInvisible();
  };

  const handlerCancel = () => {
    setInvisible();
  };

  const onUserTypeChange = (e: any) => {
    setUserType(e.target.value);
  };
  const onSchoolChange = async (value: any) => {
    let s:School = await getTable("school",value);
    if(typeof s === "undefined"){
      history.push("/");      
    }
    setSchool(s);
  };
  const onHospitalChange = async (value: any) => {
    let h:Hospital = await getTable("hospital",value);
    if(typeof h === "undefined"){
      history.push("/");      
    }
    setHospital(h);
    _getSchools(value);
  };

  return (
    <>
      <Modal
        forceRender={true}
        title="添加用户"
        visible={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText="保存"
        cancelText="取消"
      >
        <Form form={form} name="user_add">
          <Row>
            <Col span={12}>
              <Form.Item
                name="userCode"
                label="登录名"
                rules={[
                  {
                    required: true,
                    message: "不能为空!",
                  },
                ]}
              >
                <Input placeholder="登录名" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="userName"
                label="用户姓名"
                rules={[
                  {
                    required: true,
                    message: "不能为空!",
                  },
                ]}
              >
                <Input placeholder="用户姓名" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item label="用户类别" name="type">
                <Radio.Group onChange={onUserTypeChange}>
                  <Radio value={0}>平台用户</Radio>
                  <Radio value={2}>医院用户</Radio>
                  <Radio value={1}>学校用户</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          {userType === 1 && (
            <Row>
              <Col span={12}>
                <Form.Item label="所在医院" name="hospital">
                  <Select onChange={onHospitalChange} placeholder="请选择...">
                    {hospitalOptions}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="所在学校" name="school">
                  <Select onChange={onSchoolChange} placeholder="请选择...">
                    {schoolOptions}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}
          {userType === 2 && (
            <Row>
              <Col span={12}>
                <Form.Item label="所在医院" name="hospital">
                  <Select onChange={onHospitalChange} placeholder="请选择...">
                    {hospitalOptions}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}
          <Divider />
          <Typography.Title level={4}>用户权限</Typography.Title>
          <Row>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="add" label="添加受检人">
                <Checkbox />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="update" label="修改受检人">
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="delete" label="删除受检人">
                <Checkbox />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="check" label="检测">
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="report" label="查看报告">
                <Checkbox />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="user" label="用户设置">
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="data" label="导入导出">
                <Checkbox />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item valuePropName="checked" name="count" label="统计分析">
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
